import React from "react";
import FeedPublicaciones from "../components/rector/FeedPublicaciones";
import { useAuth } from "../context/AuthContext";
import { API as BASE_API, SOCKET_URL as BASE_SOCKET, UPLOADS_URL as BASE_UPLOADS } from "./config"; // ✅ Uso de config centralizada

export default function DashboardEstudiante() {
  const { user, logout } = useAuth();

  // Priorizar variables de entorno o usar los fallbacks de AWS configurados
  const API = BASE_API || "http://3.236.217.225:5001/api";
  const SOCKET_URL = BASE_SOCKET || "http://3.236.217.225:5001";
  const UPLOADS_URL = BASE_UPLOADS || "http://3.236.217.225:5001";

  return (
    <div className="min-h-screen bg-gray-50">
      
      {/* HEADER DINÁMICO */}
      <header className="bg-white shadow-sm border-b p-4 sticky top-0 z-10">
        <div className="max-w-6xl mx-auto flex justify-between items-center">
          <div className="flex items-center gap-3">
            <div className="bg-green-600 text-white p-2 rounded-lg">
              <span className="font-bold">🏫</span>
            </div>
            <div>
              <h1 className="text-lg font-bold text-gray-800 leading-tight">
                Panel Estudiantil
              </h1>
              <p className="text-xs text-gray-500 font-medium">
                {user?.nombre_sede || "Institución Educativa"}
              </p>
            </div>
          </div>

          <div className="flex items-center gap-4">
            <div className="text-right hidden sm:block">
              <p className="text-sm font-bold text-gray-700">
                {user?.nombres_estudiante || user?.nombre || "Estudiante"}
              </p>
              <p className="text-xs text-green-600">En línea</p>
            </div>
            <button 
              onClick={logout}
              className="bg-red-50 text-red-600 px-4 py-2 rounded-lg text-sm font-bold hover:bg-red-100 transition-colors border border-red-200"
            >
              Cerrar Sesión
            </button>
          </div>
        </div>
      </header>

      {/* CONTENIDO PRINCIPAL */}
      <main className="max-w-4xl mx-auto p-4 md:p-8">
        
        {/* Banner de Bienvenida */}
        <div className="bg-gradient-to-r from-green-600 to-green-500 rounded-2xl p-6 mb-8 text-white shadow-lg">
          <h2 className="text-2xl font-bold mb-2">
            ¡Hola, {user?.nombres_estudiante?.split(' ')[0] || "bienvenido"}! 👋
          </h2>
          <p className="text-green-50 opacity-90">
            Aquí encontrarás las últimas noticias y anuncios importantes de tu colegio.
          </p>
        </div>

        <div className="flex items-center gap-2 mb-6">
          <span className="text-2xl">📢</span>
          <h3 className="text-xl font-bold text-gray-800">
            Publicaciones Recientes
          </h3>
        </div>

        {/* FEED DE PUBLICACIONES */}
        <section className="bg-white rounded-2xl shadow-sm border border-gray-100 p-2 min-h-[400px]">
          <FeedPublicaciones
            API={API}
            SOCKET_URL={SOCKET_URL}
            UPLOADS_URL={UPLOADS_URL}
          />
        </section>
      </main>

      {/* FOOTER SIMPLE */}
      <footer className="py-8 text-center text-gray-400 text-sm">
        &copy; {new Date().getFullYear()} Plataforma de Gestión Académica
      </footer>
    </div>
  );
}